import { Component, OnInit, OnDestroy, Renderer2 , ViewChild, TemplateRef, ElementRef, AfterViewInit} from '@angular/core';
import { Router, NavigationStart,NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';

import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';

import { DeviceDetectorService  } from 'ngx-device-detector';

//import { NavService } from './services/nav.service';
import { SearchService } from './shared/search.service';

import { LatestBrowserVersions } from './shared/browser-versions';
import { Idle ,DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';


import { AppService } from './app.service';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AlertmessageService } from './shared/alertmessage.service';
import { AuthService } from './shared/auth.service';
import { TimeoutComponent } from './timeout/timeout.component';
import { NotificationService } from './notification/notification.service';
import { MatDialog } from '@angular/material/dialog';

export let browserRefresh=false

@Component({
  selector: 'app-root',
  templateUrl: './browser-update-template.html',
  styles: [`.alert {margin-bottom: 0rem;}`],
  //providers:[BsModalService,AppService]
  //browser-update-template.html
 // templateUrl: './app.component.html',
  // styles: [`
  //   :host {
  //     min-height: 100%;
  //   }
  // `]
})
 

export class AppComponent implements OnInit {
  modules;
  error: any;
  showHomeHeader: boolean = true;
  stickHomeHeader: boolean = false;
  routeSubscription: Subscription;
  deviceInfo: any;
  browserver: number;
  browsername: string;
  browserWarningOpen: boolean = false;
  IEbrowserWarningOpen: boolean = false;

  subscription:Subscription
  // idleState = 'Not started.';
  // timedOut = false;
  // lastPing?: Date = null;
  // title = 'angular-idle-timeout';

  // public modalRef: BsModalRef;

  // @ViewChild('childModal', {  }) childModal: ModalDirective;

  constructor(
      public location: Location,
      public router: Router,
      public renderer: Renderer2,
      public searchService: SearchService,
      private _deviceService: DeviceDetectorService ,
      //public navService: NavService
      private idle: Idle, 
      private keepalive: Keepalive,
      private appService:AppService,
      public authService:AuthService,
      private modalService: BsModalService,
      public alert:AlertmessageService,
      public _notificationService:NotificationService,
      public dialog: MatDialog
  ) {
      this.checkBrowserVersion();

      this.subscription = router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          browserRefresh = !router.navigated;
          console.log( browserRefresh )
          if(browserRefresh==true){
            this.authService.logout();
          }
        }
      });

    // idle.onTimeout.subscribe(() => {
    //   this.idleState = 'Timed out!';
    //   this.timedOut = true;
    //   console.log(this.idleState);
    //   this.authService.logout();
    //   //this.alert.openConfirmationDialog(this.idleState);
    //   this.router.navigate(['/']);
    // });
    
    // idle.onIdleStart.subscribe(() => {
    //     this.idleState = 'You\'ve gone idle!'
    //     console.log(this.idleState);
    //     this.childModal.show();
    // });
    
    // idle.onTimeoutWarning.subscribe((countdown) => {
    //   this.idleState = 'You will time out in ' + countdown + ' seconds!'
      
    //   console.log(this.idleState);
    // });

    // // sets the ping interval to 15 seconds
    // keepalive.interval(15);

    // keepalive.onPing.subscribe(() => this.lastPing = new Date());

    // this.appService.getUserLoggedIn().subscribe(userLoggedIn => {
    //   if (userLoggedIn) {
    //     idle.watch()
    //     this.timedOut = false;
    //   } else {
    //     idle.stop();
    //   }
    // })

    

    // //this.reset();

 let obj=new TimeoutComponent(idle, keepalive, appService, authService, modalService, alert, router,dialog);

  }
//session lock out

// reset() {
//     this.idle.watch();
//     this.idleState = 'Started.';
//     this.timedOut = false;
//   }
//   hideChildModal(): void {
//     this.childModal.hide();
//   }

//   stay() {
//     this.childModal.hide();
//     this.reset();
//   }

//   logout() {
//     this.childModal.hide();
//     this.appService.setUserLoggedIn(false);
//     this.authService.logout();
//     this.router.navigate(['/']);
//   }






  checkBrowserVersion() {
    this.deviceInfo = this._deviceService.getDeviceInfo();
    this.browserver = parseInt(this.deviceInfo.browser_version);
    this.browsername = this.deviceInfo.browser;
    const isMobile = this._deviceService.isMobile();
    const isTablet = this._deviceService.isTablet();
    const isDesktopDevice = this._deviceService.isDesktop();

    // console.log("deviceInfo"+this.deviceInfo+"browserver"+this.browserver+"browsername"+this.browsername);
    //  console.log(isMobile, isTablet, isDesktopDevice);

  if(this.browsername == 'IE'){
    if(LatestBrowserVersions[this.browsername] - 1 >= this.browserver) {
      this.IEbrowserWarningOpen = true;
    }  
  }
  else{
    if(LatestBrowserVersions[this.browsername] - 1 >= this.browserver) {
      this.browserWarningOpen = true; }  
    }   
  }

  ngOnInit() {
    console.log("app component");
    
      this.routeSubscription = this.router.events
         // .filter(event => event instanceof NavigationEnd)
          .subscribe(event => {
              /*
              the homepage header/footer only really seem to apply to potential clients.  this hides them on any 'admin' related route- we can also use this to swap it out for an 'admin-related' header if necessary
              */
              //this.showHomeHeader = !event['url'].includes('admin');
              this.stickHomeHeader = event['url'] !== '/';
          });
  }

  ngOnDestroy() {
      if (this.routeSubscription) { this.routeSubscription.unsubscribe(); }
  }
  
  closeBrowserWarning(){
      this.browserWarningOpen = false;
  }
  closeIEBrowserWarning(){
    this.IEbrowserWarningOpen = false;
}
}
